// import React from 'react'

// const WhatsappPrivacyPolicy = () => {
//   return (
//     <div>
//       <h3>  here is whatsapp privacy policy</h3>
//     </div>
//   )
// }

// export default WhatsappPrivacyPolicy

import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Privcy from "../../assets/footerimage/privacy-policy.jpeg";
import { Helmet } from "react-helmet-async";

const privacyPolicyData = [
  {
    heading: "1. Introduction",
    content: `This Privacy Policy explains how Deetya Soft ("Company", "we", "our", "us") collects, uses, stores, and protects your data when you use our WhatsApp Business Messaging Platform and associated services.

Your privacy and data security are extremely important to us.
By using our services, you agree to this Privacy Policy.`,
  },
  {
    heading: "2. Information We Collect",
    content: `We only collect data that is necessary for WhatsApp Business API functionality and business communication.`,
  },
  {
    heading: "2.1 Information You Provide",
    content: `• Name
• Email address
• Business details
• Login credentials (encrypted)
• WhatsApp Business Account (WABA) information
• Message templates created by you
• Assigned WhatsApp phone numbers`,
  },
  {
    heading: "2.2 Information from Facebook/Meta",
    content: `When you log in with Facebook, you authorize us to access:
• Your public profile (name, email, profile ID)
• Business Manager information
• WhatsApp Business Accounts (WABA)
• WABA phone numbers
• Template metadata and categories

We do NOT access:
• Personal messages
• Private Facebook data
• Instagram information
• Photos, posts, or friend lists
• Personal WhatsApp chat history`,
  },
  {
    heading: "3. How We Use Your Information",
    content: `Your data is used strictly to:
• Connect your WhatsApp Business Account
• Fetch and manage WhatsApp message templates
• Send WhatsApp messages via Meta APIs
• Provide analytics and reporting
• Manage your login session
• Improve service performance and stability

We do not sell or share your data with any third-party marketing agency.`,
  },
  {
    heading: "4. Data Storage & Security",
    content: `We implement strong security measures to protect your data:
• Encrypted database storage
• HTTPS secure communication
• Encrypted access token handling
• Role-based access control
• Server-level firewalls

Only authorized system components can access your information.`,
  },
  {
    heading: "5. Sharing of Information",
    content: `We never share, sell, or rent your personal or business data.

We only share data with:
Meta Platforms (Facebook/WhatsApp) as required to operate the WhatsApp Business API.
(No other third party is ever involved.)`,
  },
  {
    heading: "6. WhatsApp Message Privacy",
    content: `We do not store or read your customer WhatsApp messages.

We only store:
• Message status (sent, delivered, read)
• Metadata needed for analytics
• Template names and categories

Actual message content is never stored unless required for billing logs.`,
  },
  {
    heading: "7. Cookies & Tracking",
    content: `We may use cookies to:
• Maintain user sessions
• Improve dashboard performance
• Enhance user experience

We do not use advertising or tracking cookies.`,
  },
  {
    heading: "8. Data Retention",
    content: `We retain your data only as long as needed:
• Account details: until your account is active
• Templates & phone numbers: until you disconnect WABA
• Logs: as required by WhatsApp API compliance

You may request deletion at any time.`,
  },
  {
    heading: "9. Your Rights",
    content: `You have the right to:
• Access your data
• Update or correct your information
• Request deletion
• Disconnect your Facebook/Meta account
• Export your account data
• Withdraw consent

Send a request to info@deetyasoft.com.`,
  },
  {
    heading: "10. Children's Privacy",
    content: `Our service is not intended for children under 18.
We do not knowingly store children's personal data.`,
  },
  {
    heading: "11. Changes to the Privacy Policy",
    content: `We may update this policy occasionally.
If major changes occur, we will notify you through email or dashboard alerts.`,
  },
  {
    heading: "12. Contact Us",
    content: `If you have questions or concerns regarding privacy, reach us at:

`,
  },
];

export default function PrivacyPolicy() {
  const [activeSection, setActiveSection] = useState("");
  const currentDate = new Date().toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const handleScroll = () => {
    const scrollPosition = window.scrollY + 100;
    privacyPolicyData.forEach(({ heading }) => {
      const element = document.getElementById(heading);
      if (element && element.offsetTop <= scrollPosition) {
        setActiveSection(heading);
      }
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 20,
        behavior: "smooth",
      });
    }
  };

  return (
    <>
      <Helmet>
        <title>WhatsApp Business API Privacy Policy | Deetyasoft</title>
        <meta
          name="description"
          content="Privacy Policy for Deetyasoft WhatsApp Business Messaging Platform. Learn how we collect, use, and protect your data for WhatsApp Business API services."
        />
        <meta
          name="keywords"
          content="WhatsApp Business API privacy, data protection, WhatsApp messaging privacy, WABA privacy, business communication security, Deetyasoft privacy policy"
        />
        <link rel="canonical" href="https://deetyasoft.com/privacy-policy" />

        {/* Facebook Meta Tags */}
        <meta property="og:locale" content="en_IN" />
        <meta property="og:type" content="article" />
        <meta
          property="og:url"
          content="https://deetyasoft.com/privacy-policy"
        />
        <meta
          property="og:title"
          content="WhatsApp Business API Privacy Policy | Deetyasoft"
        />
        <meta
          property="og:description"
          content="Privacy Policy for Deetyasoft WhatsApp Business Messaging Platform. Learn how we collect, use, and protect your data for WhatsApp Business API services."
        />
        <meta
          property="og:image"
          content="https://deetyasoft.com/static/media/privacy-policy.b7385f612d39898da58c.jpeg"
        />
        <meta property="og:site_name" content="deetyasoft.com" />
        <meta
          property="article:publisher"
          content="https://www.facebook.com/deetyasoftprivatelimited"
        />

        {/* Twitter Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:url"
          content="https://deetyasoft.com/privacy-policy"
        />
        <meta
          name="twitter:title"
          content="WhatsApp Business API Privacy Policy | Deetyasoft"
        />
        <meta
          name="twitter:description"
          content="Privacy Policy for Deetyasoft WhatsApp Business Messaging Platform. Learn how we collect, use, and protect your data for WhatsApp Business API services."
        />
        <meta
          name="twitter:image"
          content="https://deetyasoft.com/static/media/privacy-policy.b7385f612d39898da58c.jpeg"
        />
        <meta name="twitter:site" content="@DeetyaSoft" />
        <meta name="twitter:creator" content="@DeetyaSoft" />

        <meta name="yandex-verification" content="31c730ea93a5a9cd" />
        <meta name="copyright" content="Deetyasoft" />
        <meta name="author" content="Deetyasoft" />
        <meta name="email" content="info@deetyasoft.com" />
        <meta name="Distribution" content="Global" />
        <meta name="rating" content="general" />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta property="bingbot" content="index, follow " />
        <meta name="Yahoobot" content="index, follow" />
        <meta name="MSNbot" content="index, follow" />
        <meta name="googlebot-news" content="index, follow" />
        <meta name="audience" content="all" />
        <meta name="geo.placename" content="Noida, Uttar Pradesh, India" />
        <meta name="geo.region" content="IN-UP" />
        <meta name="geo.position" content="28.644800;77.373300" />
        <meta name="ICBM" content="28.644800, 77.373300" />
        <link rel="alternate" href="https://deetyasoft.com" hreflang="en-us" />
        <meta httpEquiv="content-language" content="en-us" />
        <meta name="msvalidate.01" content="305155CCD42FD63B0A29555BBEE7CA03" />

        {/* Schema.org Structured Data */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "PrivacyPolicy",
              name: "WhatsApp Business API Privacy Policy",
              datePublished: currentDate,
              dateModified: currentDate,
              publisher: {
                "@type": "Organization",
                name: "Deetya Soft Pvt Ltd",
                url: "https://www.deetyasoft.com",
                logo: "https://www.deetyasoft.com/images/logo.png",
                email: "info@deetyasoft.com",
                telephone: "+91-9015350505",
              },
              description:
                "Privacy policy for Deetyasoft's WhatsApp Business Messaging Platform detailing data collection, usage, and protection practices.",
              about: "WhatsApp Business API data privacy and protection",
              text: `📄 PRIVACY POLICY

Last Updated: ${currentDate}

1. Introduction
This Privacy Policy explains how Deetya Soft ("Company", "we", "our", "us") collects, uses, stores, and protects your data when you use our WhatsApp Business Messaging Platform and associated services.

Your privacy and data security are extremely important to us.
By using our services, you agree to this Privacy Policy.

[Full privacy policy content continues...]`,
            }),
          }}
        />

        {/* Organization Schema */}
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "http://schema.org",
              "@type": "Organization",
              name: "Deetya Soft Pvt Ltd",
              description:
                "WhatsApp Business API and Cloud Communication Solutions Provider",
              image:
                "https://deetyasoft.com/static/media/privacy-policy.b7385f612d39898da58c.jpeg",
              logo: "https://www.deetyasoft.com/images/logo.png",
              url: "https://www.deetyasoft.com",
              telephone: ["+91-9015350505", "+91-9717055088"],
              email: "info@deetyasoft.com",
              sameAs: [
                "https://www.linkedin.com/company/deetya-soft-private-limited",
                "https://www.facebook.com/deetyasoftprivatelimited",
                "https://www.instagram.com/deetyasoft",
                "https://www.youtube.com/@deetyasoft",
                "https://www.crunchbase.com/organization/deetyasoft",
              ],
              address: {
                "@type": "PostalAddress",
                streetAddress:
                  "FF‑06, First Floor, Mahaluxmi Square, Plot No. C‑1, Abhay Khand II, Indirapuram",
                addressLocality: "Ghaziabad",
                addressRegion: "Uttar Pradesh",
                postalCode: "201014",
                addressCountry: "IN",
              },
            }),
          }}
        />
      </Helmet>

      <div className="relative w-full h-[60vh] md:h-[70vh] bg-black">
        {/* Background image */}
        <div className="absolute inset-0">
          <img
            src={Privcy}
            alt="WhatsApp Business API Privacy Policy"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>

        {/* Content */}
        <div className="relative z-10 flex flex-col justify-center items-start h-full px-6 md:px-16 text-white">
          <div className="text-5xl md:text-7xl mb-4">📄</div>
          <h1 className="text-4xl md:text-5xl font-bold mb-2">
            PRIVACY POLICY
          </h1>
          <div className="text-xl md:text-2xl text-gray-200 mb-4">
            WhatsApp Business Messaging Platform
          </div>
          <div className="flex items-center space-x-2 text-sm md:text-base">
            <Link to="/" className="text-white hover:underline font-bold">
              Home
            </Link>
            <span className="text-red-500">●</span>
            <span className="text-gray-300">Privacy Policy</span>
          </div>
        </div>
      </div>

      <div className="container mx-auto my-8 px-4">
        <div className="bg-white rounded-lg shadow-lg p-6 mb-8">
          <div className="text-center mb-6">
            <h2 className="text-3xl font-bold text-gray-800 mb-2">
              📄 PRIVACY POLICY
            </h2>
          </div>

          <div className="text-center text-gray-700 mb-8">
            <p className="text-lg font-medium">
              This Privacy Policy explains how <strong> Deetya Soft </strong>{" "}
              ("Company", "we", "our", "us") collects, uses, stores, and
              protects your data when you use our WhatsApp Business Messaging
              Platform and associated services.
            </p>
            <p className="mt-4 text-gray-600">
              Your privacy and data security are extremely important to us.
              <br />
              By using our services, you agree to this Privacy Policy.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-4">
          {/* Table of Contents */}
          <div className="lg:col-span-1">
            <div className="sticky top-24 bg-white shadow-lg rounded-lg p-6 border border-gray-200">
              <h3 className="text-xl font-bold mb-4 text-gray-800 border-b pb-3">
                📋 Table of Contents
              </h3>
              <ul className="space-y-1">
                {privacyPolicyData.map(({ heading }) => (
                  <li
                    key={heading}
                    className={`cursor-pointer p-3 rounded-lg transition-all duration-200 ${
                      activeSection === heading
                        ? "text-deetyasoft-blue font-semibold border-l-4 border-deetyasoft-blue bg-blue-50"
                        : "text-gray-600 hover:text-deetyasoft-blue hover:bg-gray-50"
                    }`}
                    onClick={() => scrollToSection(heading)}
                  >
                    <div className="flex items-center">
                      <span
                        className={`mr-3 ${
                          activeSection === heading
                            ? "opacity-100"
                            : "opacity-70"
                        }`}
                      >
                        {activeSection === heading ? "▶" : "•"}
                      </span>
                      <span className="text-sm md:text-base font-semibold">
                        {heading}
                      </span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {/* Main Content */}
          <div className="lg:col-span-3 space-y-3">
            {privacyPolicyData.map(({ heading, content }) => (
              <div
                id={heading}
                key={heading}
                className="bg-white rounded-xl shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow duration-300"
              >
                <h3 className="text-xl md:text-2xl font-bold text-gray-800 mb-4 pb-3 border-b border-gray-200">
                  {heading}
                </h3>
                <div className="text-gray-700 leading-relaxed">
                  {content.split("\n\n").map((paragraph, pIndex) => (
                    <div key={pIndex} className="mb-4">
                      {paragraph.split("\n").map((line, lIndex) => (
                        <div key={lIndex} className="mb-2">
                          {line.startsWith("•") ? (
                            <div className="flex items-start ml-4">
                              <span className="mr-3 text-deetyasoft-blue mt-1">
                                •
                              </span>
                              <span className="text-gray-700">
                                {line.substring(1)}
                              </span>
                            </div>
                          ) : line.includes("When you log in with Facebook") ? (
                            <div>
                              <p className="mb-3 font-medium">{line}</p>
                            </div>
                          ) : line.includes("We do NOT access:") ? (
                            <div className="mt-4">
                              <p className="mb-3 font-medium text-red-600">
                                {line}
                              </p>
                            </div>
                          ) : line.includes("📧") ||
                            line.includes("🌐") ||
                            line.includes("📞") ? (
                            <div className="flex items-center mb-2">
                              <span className="mr-3 text-xl">
                                {line.includes("📧")
                                  ? "📧"
                                  : line.includes("🌐")
                                  ? "🌐"
                                  : "📞"}
                              </span>
                              <span className="text-gray-700">
                                {line.replace(/[📧🌐📞]/g, "")}
                              </span>
                            </div>
                          ) : (
                            <p className={lIndex === 0 ? "mb-3" : "mb-2"}>
                              {line}
                            </p>
                          )}
                        </div>
                      ))}
                    </div>
                  ))}
                </div>
              </div>
            ))}

            {/* Footer Note */}
            <div className="bg-gray-50 border border-gray-200 rounded-xl p-6 mt-8">
              <div className="text-center">
                <p className="text-gray-600 mb-4">
                  If you have any questions about this Privacy Policy or how we
                  handle your data, please don't hesitate to contact us.
                </p>
                <div className="flex flex-col sm:flex-row justify-center items-center space-y-3 sm:space-y-0 sm:space-x-6">
                  <a
                    href="mailto:info@deetyasoft.com"
                    className="flex items-center text-deetyasoft-blue hover:text-deetyasoft-darkblue font-medium"
                  >
                    <span className="mr-2">📧</span>

                    <span className=" text-blue-600">
                      info@deetyasoft.com
                    </span>
                  </a>
                  <a
                    href="tel:+919015350505"
                    className="flex items-center text-deetyasoft-blue hover:text-deetyasoft-darkblue font-medium"
                  >
                    <span className="mr-2">📞</span> +91-9015350505
                  </a>
                  <a
                    href="https://deetyasoft.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center text-deetyasoft-blue hover:text-deetyasoft-darkblue font-medium"
                  >
                    <span className="mr-2">🌐</span>{" "}
                    <span className=" text-blue-600">
                      https://deetyasoft.com/{" "}
                    </span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
